import React, { useState, useRef, useEffect } from 'react';

import Image from '../../images/user-avatar-80.png';
import AlertModal from '../AlertModal'
import { updateClientUser } from '../../graphql/mutations';
import { API } from 'aws-amplify';

import jBox from 'jbox'
import 'jbox/dist/jBox.all.css';

function WebPushCreate({userDetails, authToken, logout}) {

  const [sync, setSync] = useState(false);
  const pushBtnRef = useRef()
  const [loadingVisible, setLoadingVisible] = useState(false);
  const [alertModalState, setAlertModalState] = useState(null)

  const [ticker, setTicker] = useState('')
  const [content, setContent] = useState('')

  useEffect(() => {
  }, []);

  function tickerChange(e){
    setTicker(e.target.value)
  }

  function contentChange(e){
    setContent(e.target.value)
  }

  async function pushNotification(){
    console.log('Sending notification')
    if(userDetails.webPushAlias!='' && userDetails.webPushAlias!=undefined) {
      if (ticker != '' && content != '') {
        pushBtnRef.current.setAttribute("disabled", true)
        const apiName = 'DashboardAPI'; // replace this with your api name.
        const path = '/web-push/push-notification'; //replace this with the path you have configured on your API
        const myInit = {
          body: {
            clientUserId: userDetails.id,
            alias: userDetails.webPushAlias,
            ticker: ticker,
            content: content,
          },
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        };
        API
          .post(apiName, path, myInit)
          .then(response => {
            pushBtnRef.current.removeAttribute('disabled')
            if (response['sent'])
              new jBox('Notice', {content: 'Push successful.', color: 'green', position: {x: 'center', y: 20}});
            else
              new jBox('Notice', {
                content: 'Woops. Push unsuccessful. Try again later.',
                color: 'red',
                position: {x: 'center', y: 20}
              });
          })
          .catch(error => {
            pushBtnRef.current.removeAttribute('disabled')
            new jBox('Notice', {
              content: 'Woops. Push unsuccessful. Try again later.',
              color: 'red',
              position: {x: 'center', y: 20}
            });
          });
      } else {
        new jBox('Notice', {content: 'Notification must not be empty.', color: 'red', position: {x: 'center', y: 20}});
      }
    }
    else{
      new jBox('Notice', {content: 'You must have an Alias to push notifications. Update your Alias in ' +
          'the "My Profile" section.', color: 'blue', position: {x: 'center', y: 'center'}});
    }


  }

  return (
    <div className="flex-grow">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        <h2 className="text-2xl text-gray-800 font-bold mb-5">Push Creation</h2>

        {/*<section>
          <div className="flex items-center">

            <div className="sm:w-2/3">
              <div className="text-sm" style={{"textAlign": "justify"}}>These details are used to populate your web push subscription page. Your subscription page is where your
                audience can subscribe to your Web Push-notifications. Your subscription page will be public, so be mindful
                what you include. You can share your unique subscription link to help your audience find you: link here.</div>
            </div>
          </div>
        </section>*/}
        {/* Picture */}
        {/*<section>
          <div className="flex items-center">
            <div className="mr-4">
              <img className="w-20 h-20 rounded-full" src={Image} width="80" height="80" alt="User upload" />
            </div>
            <button className="btn-sm bg-pink-500 hover:bg-pink-600 text-white">Change</button>
          </div>
        </section>*/}
        {/* ticker */}
        <section>
          <h2 className="text-xl leading-snug text-gray-800 font-bold mb-1">Ticker Text</h2>
          <div className="text-sm">The subject line of the web push notification.</div>
          <div className="flex flex-wrap mt-5">
            <div className="mr-2">
              <label className="sr-only" htmlFor="email">Ticker Text</label>
              <input id="alias" className="form-input" type="text" placeholder="Ticker content.."
                     onChange={tickerChange}/>
            </div>
          </div>
        </section>
        {/* content */}
        <section>
          <h2 className="text-xl leading-snug text-gray-800 font-bold mb-1">Push Body</h2>
          <div className="text-sm">Content of the web push.</div>
          <div className="flex flex-wrap mt-5 sm:w-1/3">
            <label className="sr-only" htmlFor="description">Push Content</label>
            <textarea id="description" className="form-textarea focus:border-gray-300 w-full" rows="4"
                      placeholder="Web push content.." onChange={contentChange} ></textarea>
          </div>
        </section>
      </div>
      {/* Panel footer */}
      <footer>
        <div className="flex flex-col px-6 py-5 border-t border-gray-200">
          <div className="flex self-end">
            <button className="btn bg-pink-500 hover:bg-pink-600 text-white ml-3 disabled:opacity-50"
                    onClick={pushNotification} ref={pushBtnRef}>Push Notification</button>
          </div>
        </div>
      </footer>

      <AlertModal params={alertModalState} toggleState={setAlertModalState}/>
    </div>
  );
}

export default WebPushCreate;